import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';
import { routes } from '../../../shared/routes';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router = inject(Router);
    const authService = inject(AuthService);

    return authService.isLoggedIn$.pipe(
        switchMap((isLoggedIn) => {
            if (!isLoggedIn) {
                router.navigate([routes.signIn]);
                return of(false);
            }
            return of(true);
        }),
    );
};
